import { createSelector } from 'reselect'
import { isExpiredPromoCodeUtil } from 'models/daos/promo-code/utils'
import { getPromoCodeSelector } from 'modules/promo-codes/selectors'

/**
 * Returns the promo code if it's not expired.
 * @returns {Function}
 */
function getNonExpiredPromoCodeSelector () {
  return createSelector(
    getPromoCodeSelector(),
    (promoCode) => {
      if (!promoCode || isExpiredPromoCodeUtil(promoCode)) {
        return null
      }
      return promoCode
    }
  )
}

export default getNonExpiredPromoCodeSelector
